import script from "./Submenu.vue?vue&type=script&setup=true&lang=js"
export * from "./Submenu.vue?vue&type=script&setup=true&lang=js"

import "./Submenu.vue?vue&type=style&index=0&id=07f09f3b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f09f3b"]])

export default __exports__